/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Toast_Approve_Out_NoteInputs */

const vi_pl_toast_approve_out_note = /** @type {(inputs: Pl_Toast_Approve_Out_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã duyệt phiếu xuất lô chè mua`)
};

/**

* @param {Pl_Toast_Approve_Out_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_toast_approve_out_note = /** @type {((inputs?: Pl_Toast_Approve_Out_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Toast_Approve_Out_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_toast_approve_out_note(inputs)
});